import { LucideIcon, LucideProps } from 'lucide-react';

export const AddSymbol = (props: LucideProps | React.SVGProps<SVGCircleElement>): React.ReactElement => {
	const { cx: pcx, cy: pcy, r, opacity } = props;
	const cx = Number(pcx);
	const cy = Number(pcy);
	const x = cx - (Number(props.r));
	const y = cy - (Number(props.r));
	const height = Number(props.r) * 2;
	const width = Number(props.r) * 2;

	return (<g>
		{/* <rect fill="yellow" x={x} y={y} height={height} width={width}></rect> */}
		<svg viewBox="6 6 12 12" x={x} y={y} height={height} width={width} opacity={opacity}>
			<path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"></path>
		</svg>
	</g>);
};
